import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './layout/App.Router';
import reportWebVitals from './reportWebVitals';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_test_51RJuR0046lfAB8p8VyYaeL9V8R0qkNsGOWTMoGDiE3c0ynwL2zqGlhYbOarwYV2cqeLGmDDmfn69FKD6S52dtoq800H0X3v9qz'); 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Elements stripe={stripePromise}>
      <App />
    </Elements>
  </React.StrictMode>
);

reportWebVitals();
